const Service = () => {
    return ( 
        <div className="service">
            <div className="section techwix-choose-us-section section-padding" style={{backgroundImage: "url(assets/images/bg/choose-us-bg3.jpg)"}}>
            <div className="container">
                <div className="choose-us-wrap">
                    <div className="section-title text-center">
                        <h3 className="sub-title">REASON TO CHOOSE US</h3>
                        <h2 className="title">Our Core Values</h2>
                    </div>
                    <div className="choose-us-content-wrap">
                        <div className="row">
                            <div className="col-xl-3 col-lg-4 col-md-6">
                                <div className="choose-us-item-02">
                                    <div className="choose-us-img">
                                        <img src="assets/images/ser-icon9.png" alt="" />
                                    </div>
                                    <div className="choose-us-content">
                                        <h3 className="title"><a href="service.html">Courage</a></h3>
                                        <p>We are bold and unafraid to set the pace, pioneering new paths, and setting industry standards.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6">
                                <div className="choose-us-item-02">
                                    <div className="choose-us-img">
                                        <img src="assets/images/counter-2.png" alt="" />
                                    </div>
                                    <div className="choose-us-content">
                                        <h3 className="title"><a href="service.html">Innovation & Ingenuity</a></h3>
                                        <p>Consistently generate innovative ideas, using technology to improve the world.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6">
                                <div className="choose-us-item-02">
                                    <div className="choose-us-img">
                                        <img src="assets/images/ser-icon10.png" alt="" />
                                    </div>
                                    <div className="choose-us-content">
                                        <h3 className="title"><a href="service.html">Customer & Users Satisfaction</a></h3>
                                        <p>We focus on satisfying our users, clients, and stakeholders.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6">
                                <div className="choose-us-item-02">
                                    <div className="choose-us-img">
                                        <img src="assets/images/ser-icon12.png" alt="" />
                                    </div>
                                    <div className="choose-us-content">
                                        <h3 className="title"><a href="service.html">Integrity and Honesty</a></h3>
                                        <p>We prioritize fairness and transparency in all business dealings and activities.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6">
                                <div className="choose-us-item-02">
                                    <div className="choose-us-img">
                                        <img src="assets/images/counter-1.png" alt=""/>
                                    </div>
                                    <div className="choose-us-content">
                                        <h3 className="title"><a href="service.html">Teamwork and Collaboration</a></h3>
                                        <p>Team up, collaborate for our shared goals.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6">
                                <div className="choose-us-item-02">
                                    <div className="choose-us-img">
                                        <img src="assets/images/counter-3.png" alt="" />
                                    </div>
                                    <div className="choose-us-content">
                                        <h3 className="title"><a href="service.html">Leadership & Professionalism</a></h3>
                                        <p>Professional leadership in all we do.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6">
                                <div className="choose-us-item-02">
                                    <div className="choose-us-img">
                                        <img src="assets/images/ser-icon21.png" alt="" />
                                    </div>
                                    <div className="choose-us-content">
                                        <h3 className="title"><a href="service.html">Excellence</a></h3>
                                        <p>Consistently providing excellent service delivery to our clients.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6">
                                <div className="choose-us-item-02">
                                    <div className="choose-us-img">
                                        <img src="assets/images/ser-icon22.png" alt="" />
                                    </div>
                                    <div className="choose-us-content">
                                        <h3 className="title"><a href="service.html">Simplicity</a></h3>
                                        <p>keep our products and services simple and user friendly.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="section techwix-skill-section-02 techwix-skill-section-03 section-padding">
            <div className="container">
                <div className="skill-wrap">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="skill-left">
                                <div className="section-title">
                                    <h2 className="title">Preparing for your success, we provide truly prominent IT solutions</h2>
                                </div>
                                <div className="about-list">
                                    <ul>
                                        <li>
                                            <span className="about-icon"><i className="fas fa-check"></i></span>
                                            <span className="about-text">We always focus on technical excellence </span>
                                        </li>
                                        <li>
                                            <span className="about-icon"><i className="fas fa-check"></i></span>
                                            <span className="about-text"> Wherever you’re going, we bring ideas and excitement </span>
                                        </li>
                                        <li>
                                            <span className="about-icon"><i className="fas fa-check"></i></span>
                                            <span className="about-text">We’re consultants, guides, and partners for brands </span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="about-author-info-wrap">
                                    {/* <div className="about-author">
                                        <img src="assets/images/sign.png" alt="Signature" />
                                        <h3 className="name">Okoro Oreva</h3>
                                        <span className="designation">CEO & Founder, TMT</span>
                                    </div> */}
                                    <div className="about-info">
                                        <p>Call to ask any question </p>
                                        <a href="tel:+2349038224320">
                                        <h3 className="number">+234 903-822-4320</h3></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="skill-right">
                                <p className="text">We drive innovation with top-tier tech teams. We have team of exceptional skills-set for your software development requirements, including cloud, infrastructure, and network solutions. Our primary goal is to understand your business needs and deliver tailored solutions that precisely meet your demands.</p>
                                <div className="counter-bar">
                                    <div className="skill-item">
                                        <span className="title">IT Managment</span>
                                        <div className="skill-bar">
                                            <div className="bar-inner">
                                                <div className="bar progress-line color-1" data-width="80">
                                                    <span className="skill-percent"><span className="cnter">80</span>%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="skill-item">
                                        <span className="title">Data Security</span>
                                        <div className="skill-bar">
                                            <div className="bar-inner">
                                                <div className="bar progress-line color-1" data-width="95">
                                                    <span className="skill-percent"><span className="">95</span>%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="skill-item">
                                        <span className="title">Information Technology</span>
                                        <div className="skill-bar">
                                            <div className="bar-inner">
                                                <div className="bar progress-line color-1" data-width="80">
                                                    <span className="skill-percent"><span className="">80</span>%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="skill-item">
                                        <span className="title">Technology Consultant</span>
                                        <div className="skill-bar">
                                            <div className="bar-inner">
                                                <div className="bar progress-line color-1" data-width="90">
                                                    <span className="skill-percent"><span className="">90</span>%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
     );
}
 
export default Service;